module.exports = __webpack_public_path__ + "img/container2Logo1.a0aaf36a.png";